module.exports = __webpack_public_path__ + "static/media/Vajira.98cac05c.jpg";